import {getSheet} from "../sheets";

export function init(view) {
	view.attachEvent("onUndo", (action, row, column, value) => {
		if (action == "show-formulas"){
			showFormulas(view, value);
		}
	});
}

export function showFormulas(view, value, page){
	page = page || view.getActiveSheet();
	let old;

	if (page == view.getActiveSheet()) {
		const grid = view.$$("cells");
		old = grid.config.showFormulas;

		if(value == "toggle")
			value = !old;

		if(value != old){
			grid.config.showFormulas = value;

			view.callEvent("onCommand", [{id:"toolbar-update", name:"show-formulas", value}]);
			grid.refresh();
		}
	}
	else{
		const sheet = getSheet(view, page);
		if(sheet){
			if(!sheet.content.table)
				sheet.content.table = {showFormulas: 1};

			old = sheet.content.table.showFormulas;

			if (value == "toggle")
				value = !old;

			sheet.content.table.showFormulas = value ? 1 : 0;
		}
		else return;
	}

	if(value != old)
		view.callEvent("onAction", ["show-formulas", {newValue: value, value: old, page}]);
}

export function serialize(view, data){
	data.table.showFormulas = view.$$("cells").config.showFormulas ? 1 : 0;
}

export function load(view, data){
	let mode = false;
	if(data.table && data.table.showFormulas)
		mode = data.table.showFormulas;
	showFormulas(view, mode);
}